import {createRouter, createWebHistory} from 'vue-router';
import routes from './routes';
import AuthService from "@/services/auth.service";

const router = createRouter({
    history: createWebHistory(),
    routes
})

const unauthenticatedPages = [
    "Login",
]

router.beforeEach(async (to, _, next) => {
    const tokens = JSON.parse(sessionStorage.getItem('auth'));
    const hasToken = tokens && Object.keys(tokens).length > 0;

    if (unauthenticatedPages.includes(to.name) && hasToken) {
        next({name: 'LabHub'});
        return;
    }

    if (!unauthenticatedPages.includes(to.name) && !hasToken) {
        next({name: 'Login'});
        return;
    }

    await checkAccess(to);

    next();
});

async function checkAccess(route) {
    if (unauthenticatedPages.includes(route.name)) {
        return;
    }

    if (route.name === 'LabHub') {
        return;
    }

    if (await AuthService.hasAccess(route.name)) {
        return;
    }

    await router.push({name: 'NotFound'});
}

export default router;